type JSONPrimitive = string | number | boolean | null | undefined
type JSONValue = JSONPrimitive | JSONObject | JSONArray
type JSONArray = JSONValue[]
type JSONObject = { [member: string]: JSONValue }

declare global {
  interface Window {
    dataLayer?: JSONArray
  }
}
export const gtag = (...args: JSONArray) => {
  window.dataLayer = window.dataLayer ? window.dataLayer : []
  window.dataLayer.push(...args)
}

export const gtagFields = Object.freeze({
  event: {
    page_view: 'page_view',
    login: 'login',
    signup_request: 'signup_request',
    signup_confirmation: 'signup_confirmation',
    sign_up_start: 'sign_up_start',
    sign_up_step: 'sign_up_step',
    sign_up_submit: 'sign_up_submit',
    sign_up: 'sign_up',
    business_tax_complete: 'business_tax_complete',
  },
  website_flow: '3MP',
  platform: '3mp',
  method: {
    fusionAuth: 'fusionauth',
  },
  user_status: {
    logged_in: 'logged_in',
    logged_out: 'guest',
  },
})
